import {type ReactNode} from 'react';
import {Typography} from '@mui/material';

export type PlaceholderProps = {
  children: ReactNode;
}

const Placeholder = ({children, ...props} : PlaceholderProps) => (
  <Typography color='textSecondary' {...props} variant='placeholder'>{children}</Typography>
)

export default Placeholder;